import React from 'react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils'

import { DueStatus } from '../types'

interface MyWorkDueTagProps {
  status: DueStatus
}

export const MyWorkDueTag: React.FC<MyWorkDueTagProps> = ({ status }) => {
  const { t } = useTranslation()

  if (status === DueStatus.NONE) {
    return null
  }

  const getTagContent = () => {
    switch (status) {
      case DueStatus.OVERDUE:
        return <span>{t('myWork.dueStatus.overdue')}</span>
      case DueStatus.DUE_TODAY:
        return <span>{t('myWork.dueStatus.dueToday')}</span>
      case DueStatus.DUE_THIS_WEEK:
        return <span>{t('myWork.dueStatus.dueThisWeek')}</span>
      default:
        return null
    }
  }

  const getTagStyle = () => {
    switch (status) {
      case DueStatus.OVERDUE:
        return 'border-solid border-error-700 text-error-700 bg-error-200'
      case DueStatus.DUE_TODAY:
        return 'border-solid border-amber-600 text-amber-700 bg-amber-100'
      case DueStatus.DUE_THIS_WEEK:
        return 'border-solid border-purple-600 text-purple-700 bg-purple-100'

      default:
        return ''
    }
  }

  return (
    <Badge
      variant="outline"
      size="sm"
      className={cn('inline-flex w-fit whitespace-nowrap', getTagStyle())}
    >
      {getTagContent()}
    </Badge>
  )
}
